import { mapActions, mapGetters } from 'vuex';
import sidebarIcon from '@/components/icons/sidebar-icon';

export default {
  components: {
    sidebarIcon,
  },
  data() {
    return {
      isCategoriesLabelVisible: false,
    };
  },
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapGetters('app', [
      'isLayoutMobile',
      'isLayoutDesktop',
      'isPinboardSingleModeVisible',
      'isPinningEnabled',
      'sidebarVisible',
    ]),
    externalBrowseHeaders() {
      return this.userBrowseHeaders.filter((item) => item.external);
    },
    categoryBrowseHeaders() {
      return this.userBrowseHeaders.filter((item) => !item.external);
    },
    categoriesIcon() {
      // if (this.isLayoutDesktop) {
      //   return this.iconClassModifiers({ icon: 'globe' });
      // }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    isAllMarketsLinkActive() {
      return this.$route.name === 'market-list' && !parseInt(this.$route.params.headerId, 10);
    },
    classModifiers() {
      return {
        'nav-browse': true,
        'nav-browse--desktop': !this.isLayoutMobile,
        'nav-browse--mobile': this.isLayoutMobile,
      };
    },
    showSidebarToggle() {
      return this.isLayoutDesktop && this.isPinningEnabled && this.isPinboardSingleModeVisible;
    },
  },
  methods: {
    ...mapActions('browse', ['toggleNavBrowseCategoriesOverlay']),
    ...mapActions('app', ['toggleSidebarVisible']),
    toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.toggleNavBrowseCategoriesOverlay();
      }
    },
    iconClassModifiers(item) {
      return {
        'nav-browse__link-icon': true,
        [`nav-browse__link-icon--${item.icon}`]: item.icon,
      };
    },
    toggleSidebar() {
      this.toggleSidebarVisible();
    },
  },
  mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  },
};
